<h1 class="title"
	mat-dialog-title>{{ title }}</h1>

<div [innerHtml]="message"
	 class="content"
	 mat-dialog-content>
</div>

<div align="end"
	 mat-dialog-actions>

	@for (button of buttons; track $index) {

		<button (click)="close(button)"
				class="mat-primary"
				mat-flat-button type="button">
			
			{{ button }}

		</button>

	}

</div>